import "./TrackAndTraceElement.less";

class TrackAndTraceElement extends HTMLElement {
    
    static get observedAttributes() { return ["document-number"]; }



    public static readonly tag = "track-and-trace";
    async connectedCallback() {
       
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.refresh();
    }

    private fetchWithRetry = async (url, options = {}, retries = 3, delay = 500) => {
        for (let attempt = 1; attempt <= retries; attempt++) {
            try {
                const response = await fetch(url, options);
    
                if (response.ok && response.status !== 204) { // 204 No Content is not an error, but we don't want to process it
                    return response;
                }
    
                console.warn(`Fetch failed (attempt ${attempt}): ${response.status} ${response.statusText}`);
            } catch (err) {
                console.warn(`Fetch error (attempt ${attempt}):`, err);
            }
    
            if (attempt < retries) {
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    
        return null;
    }
    

    private refresh = async () => {
        this.innerHTML = this.initialView();

        let response = await this.fetchWithRetry("https://r2.eurowheels.dk/fleet/api/track-and-trace/"+ this.getAttribute("document-number")); // 921442
        //let response = await this.fetchWithRetry("https://localhost:5000/api/track-and-trace/"+ this.getAttribute("document-number")); // 921442

        if (!response.ok) {
            this.innerHTML = `<div class="alert alert-danger">Der opstod en fejl under hentning af data.</div>`;
            return;
        }


        let model: TrackAndTraceViewModel;
        
        try {
            model = await response.json() as TrackAndTraceViewModel;
        } catch (error) {
            this.innerHTML = `<div class="alert alert-danger">Der opstod en fejl under behandling af data.</div>`;
            return;
        }
        
        this.innerHTML = this.view(model);


        if (model.eta)  {
            setTimeout(this.refresh, 1000 * 60 * 2); // Refresh every 2 minutes
        }
    }

    private pad(no: number, wantedLength = 2, symbol = "0") {
        const source = no.toString();
        return source.length >= wantedLength ? source : new Array(wantedLength - source.length + 1).join(symbol) + source;
    }

    private formatTime = (date: Date) => {
        if (date.getDate() === new Date().getDate())
            return `${date.getHours()}:${this.pad(date.getMinutes())}`;
        else
            return `${date.getDate()}/${date.getMonth() + 1} ${date.getHours()}:${this.pad(date.getMinutes())}`;
    }


    private initialView = (): string => `
        <div class="modal-body">
            <div class="progress progress-striped active">
                <div class="bar" style="width: 100%;"></div>
            </div>
        </div>
    `;

    private etaView = (eta: string): string => {
        if (!eta) {
            return '';
        }
        const date = new Date(eta); //`${eta}Z`

        return `
            <div class="field">
                <div class="field-label">Forventet levering</div>
                <div class="field-value">
                    ${this.formatTime(date)}
                    ${require("./Images/refresh.svg")}
                </div> 
                <div class="comment">(opdateret ${this.formatTime(new Date())})</div>
            </div>
        `;
    }

    private view = (model: TrackAndTraceViewModel): string => `
        <div class="modal-body">
            <div class="field">
                <div class="field-label">Speditør</div>
                <div class="field-value">Eurowheels</div>
            </div>
            ${model.eta ? this.etaView(model.eta) : ''}
            <p>&nbsp;</p>
            <table class="table">
                <thead>
                    <tr>
                        
                        <th>Chauffør</th>
                        <th>Info</th>
                        <th>Dato og tid</th>
                    </tr>
                </thead>
                <tbody>
                   ${model.events.map(event => `
                        <tr>
                            <td>${event.createdBy}</td>
                            <td style="display:flex; justify-content: space-between;">
                                ${event.text}
                                ${event.attachementId ? `
                                    <delivery-picture style="cursor: pointer;"
                                        target="body"
                                        original-source="https://r2.eurowheels.dk/fleet/api/attachments/${event.attachementId}"
                                        source="https://r2.eurowheels.dk/fleet/api/attachments/small/${event.attachementId}">
                                    </delivery-picture>
                                ` : ''}
                                
                            </td>
                            <td>${new Date(event.createdAt).toLocaleString()}</td>
                        </tr>
                   `).join('')} 
                </tbody>
            </table>
        </div>
    `;
}

customElements.define(TrackAndTraceElement.tag, TrackAndTraceElement);

interface TrackAndTraceViewModel {
    id: string;
    status: string;
    events: TrackAndTraceEvent[];
    eta?: string;
}

interface TrackAndTraceEvent {
    text: string;
    createdBy: string;
    createdAt: string;
    attachementId: string;
}